<section class="outer_seo_page_component_container">
  <section class="meet_handyhands_container inner_seo_page_component_container">
    <div class="meet_hh_1">
      <div class="inner nr2">
        <h2 class="title">
          {{ 'PAGES.LANDING.OWN_BOSS' | translate }}
        </h2>
        <p>
          {{ 'PAGES.LANDING.OWN_BOSS_DESC' | translate }}
        </p>

        <div class="usp_container">
          <div class="usp_wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
            >
              <path
                d="M7.93848 10.2512L11.3244 14.991C11.4638 15.1861 11.6461 15.3467 11.8572 15.4604C12.0684 15.574 12.3028 15.6378 12.5424 15.6467C12.782 15.6557 13.0205 15.6095 13.2396 15.5119C13.4586 15.4142 13.6523 15.2677 13.8058 15.0835L24.8991 1.7699"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="head_wrapper">
              <p>{{ 'PAGES.LANDING.OWN_BOSS_USP_1' | translate }}</p>
            </div>
          </div>

          <div class="usp_wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
            >
              <path
                d="M7.93848 10.2512L11.3244 14.991C11.4638 15.1861 11.6461 15.3467 11.8572 15.4604C12.0684 15.574 12.3028 15.6378 12.5424 15.6467C12.782 15.6557 13.0205 15.6095 13.2396 15.5119C13.4586 15.4142 13.6523 15.2677 13.8058 15.0835L24.8991 1.7699"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="head_wrapper">
              <p>
                {{ 'PAGES.LANDING.OWN_BOSS_USP_2' | translate }}
              </p>
            </div>
          </div>

          <div class="usp_wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
            >
              <path
                d="M7.93848 10.2512L11.3244 14.991C11.4638 15.1861 11.6461 15.3467 11.8572 15.4604C12.0684 15.574 12.3028 15.6378 12.5424 15.6467C12.782 15.6557 13.0205 15.6095 13.2396 15.5119C13.4586 15.4142 13.6523 15.2677 13.8058 15.0835L24.8991 1.7699"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="head_wrapper">
              <p>{{ 'PAGES.LANDING.OWN_BOSS_USP_3' | translate }}</p>
            </div>
          </div>

          <div class="button_div">
            <app-generic-button-with-arrow
              [color_string]="'more_info_button'"
              [label]="'PAGES.LANDING.EARN' | translate"
              (onClick)="router.navigate([findWorkPath])"
            ></app-generic-button-with-arrow>
          </div>
        </div>
      </div>

      <div class="handyhand_img_container">
        <img
          [width]="556"
          [height]="632"
          loading="lazy"
          [ngSrc]="'/assets/svg/user/own-boss.svg'"
          alt="handyman"
        />
      </div>
    </div>
  </section>
</section>
